import { useTranslation } from "react-i18next";

import { Text } from "@krea/customer-features/shared-components/text";
import { twMerge } from "@krea/shared/design-system/tailwind-utils";

interface IPostSelectBidLenderCommentProps {
  comment: string;
  className?: string;
}

const PostSelectBidLenderComment = ({
  comment,
  className,
}: IPostSelectBidLenderCommentProps) => {
  const { t } = useTranslation();

  return (
    <dl
      className={twMerge(
        "tw-border tw-border-orange tw-rounded tw-bg-primary-150/40 tw-p-2 tw-mx-0",
        className,
      )}
    >
      <Text htmlTag="dt" size="sm" className="tw-m-0 tw-p-0">
        {t(`postSelect.lenderComment`)}:
      </Text>

      <Text htmlTag="dd" size="sm" className="tw-m-0 tw-p-0">
        {comment}
      </Text>
    </dl>
  );
};

export default PostSelectBidLenderComment;
